export const COMPANY_DELETE_COMPANY_BEGIN = 'COMPANY_DELETE_COMPANY_BEGIN';
export const COMPANY_DELETE_COMPANY_SUCCESS = 'COMPANY_DELETE_COMPANY_SUCCESS';
export const COMPANY_DELETE_COMPANY_FAILURE = 'COMPANY_DELETE_COMPANY_FAILURE';
export const COMPANY_DELETE_COMPANY_DISMISS_ERROR = 'COMPANY_DELETE_COMPANY_DISMISS_ERROR';
export const COMPANY_SETUP_CONFIGURATION_BEGIN = 'COMPANY_SETUP_CONFIGURATION_BEGIN';
export const COMPANY_SETUP_CONFIGURATION_SUCCESS = 'COMPANY_SETUP_CONFIGURATION_SUCCESS';
export const COMPANY_SETUP_CONFIGURATION_FAILURE = 'COMPANY_SETUP_CONFIGURATION_FAILURE';
export const COMPANY_SETUP_CONFIGURATION_DISMISS_ERROR = 'COMPANY_SETUP_CONFIGURATION_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/company/redux/constants.js